import { createFileRoute } from '@tanstack/react-router';
import { SupportTicketsPage } from '@/pages/help/SupportTicketsPage';

export const Route = createFileRoute('/$slug/help/tickets/')({
  component: SupportTicketsPage
});
